// extracted by mini-css-extract-plugin
export default {"aboutSection":"About_aboutSection__3RKhi","childAboutSection":"About_childAboutSection__fuWnn","head":"About_head__UZS7z"};